import React from 'react'

import {Button} from '../../../src/components/UI/index.js'

/**
 * A button of the bottom NavBar: the icon above the label, the active one darker. The buttons share the bar's width
 * and fill its height, so they are large touch targets.
 */
export default function NavButton({style = {}, active, label, icon, onClick, type, disabled}) {
    return (
        <Button
            variant='nav'
            labelPosition='bottom'
            style={{flex: 1, height: '100%', ...style}}
            type={type}
            selected={active}
            icon={icon}
            label={label}
            disabled={disabled}
            onClick={onClick}
        />
    )
}
